import { isHousehold } from '@frontend/api-client';
import { PageContainer } from '@frontend/web-react';
import {
  HouseholdMembersSection,
  HouseholdUpgradeCTA,
} from '@frontend/web/components/DomainSpecific/Settings/ManageHousehold';
import { useRetrieveClientQuery, useRetrieveHouseholdQuery } from '@frontend/web/hooks';
import { createFileRoute } from '@tanstack/react-router';

const ManageHousehold = () => {
  const { data: client, isLoading: isClientLoading } = useRetrieveClientQuery();
  const { data: household, isLoading: isHouseholdLoading } = useRetrieveHouseholdQuery(client?.household ?? '', {
    skip: !client?.household,
  });
  const isHouseholdPlan = isHousehold(client?.plan?.code);

  return (
    <PageContainer headerTitle="Manage Household" isLoading={isClientLoading || isHouseholdLoading}>
      {!isHouseholdPlan ? <HouseholdUpgradeCTA /> : null}
      {isHouseholdPlan && household && client ? (
        <HouseholdMembersSection client={client} household={household} />
      ) : null}
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/settings/manage-household')({
  component: ManageHousehold,
});
